import config from 'config';
import _ from 'lodash';
import {
  GOAL,
  OWNGOAL,
  PENALTY,
  SUBON,
  SUBOFF,
  YELLOWCARD,
  SECONDYELLOWCARD,
  REDCARD
} from 'modules/Football/consts'

export const LOAD_MATCH_AND_EVENTS = 'football/match/LOAD_MATCH_AND_EVENTS';
export const LOAD_MATCH_AND_EVENTS_SUCCESS = 'football/match/LOAD_MATCH_AND_EVENTS_SUCCESS';
export const LOAD_MATCH_AND_EVENTS_FAIL = 'football/match/LOAD_MATCH_AND_EVENTS_FAIL';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOAD_MATCH_AND_EVENTS:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          matchLoading: true
        }
      };
    case LOAD_MATCH_AND_EVENTS_SUCCESS: {
      const currentMatch = transformMatch(state[action.matchId].match, action.result.matchDetails);
      const events = transformEvent(currentMatch, action.result.eventData);
      const {
        [action.matchId]: {
          events: stateEvents = {}
        } = {}
      } = state || {};

      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          matchLoading: false,
          matchLoaded: true,
          match: currentMatch,
          events: {...stateEvents, ...events.events},
          last_modified_date: events.last_modified_date
        }
      };
    }
    case LOAD_MATCH_AND_EVENTS_FAIL:
      return {
        ...state,
        [action.matchId]: {
          ...state[action.matchId],
          matchLoading: false,
          matchLoaded: false,
          error: action.error
        }
      };

    default:
      return state;
  }
}

export function isMatchLoading(globalState, matchId) {
  return globalState.football.match[matchId]
      && globalState.football.match[matchId].matchLoading;
}

export function loadMatchAndEvents(matchId, last_modified_date) {
  return {
    types: [LOAD_MATCH_AND_EVENTS, LOAD_MATCH_AND_EVENTS_SUCCESS, LOAD_MATCH_AND_EVENTS_FAIL],
    matchId: matchId,
    promise: (client) => Promise.all([
      client.get(`${config.api.football.matchDetail}/${matchId}`),
      client.get(config.api.football.matchEvents, {params: {match_id: matchId, last_modified_date, include_all_types: true}})
    ]).then(results => ({
      matchDetails: results[0],
      eventData: results[1]
    }))
  };
}

function transformMatch({match_detail: matchDetail, homeTeam, awayTeam} = {}, resp) {
  let hTeamPlayers = homeTeam ? homeTeam.players.players : [];
  let aTeamPlayers = awayTeam ? awayTeam.players.players : [];
  
  let aggregate_score;

  const {
    team_score_a: {
      aggregate_score: teamAAggregate,
    } = {},
    team_score_b: {
      aggregate_score: teamBAggregate,
    } = {},
    team_statistics_a = {},
    team_statistics_b = {}
  } = resp;

  if ((teamAAggregate != undefined) && (teamBAggregate != undefined)) {
    aggregate_score = {
      home: resp.team_score_a.aggregate_score,
      away: resp.team_score_b.aggregate_score
    };
  }
  
  return {
    homeTeam: transformTeam(hTeamPlayers, resp.lineup_a, resp.team_score_a.team, resp.formation_a),
    awayTeam: transformTeam(aTeamPlayers, resp.lineup_b, resp.team_score_b.team, resp.formation_b),
    match_detail: {
      match_reference: resp.match_reference,
      match_date: resp.match_date,
      match_time: resp.match_time,
      match_outcome: resp.match_outcome,
      competition: resp.competition,
      team_score_a: {
        team: resp.team_score_a.team,
        total_goals: resp.team_score_a.score[0].score,
        goals: matchDetail ? matchDetail.team_score_a.goals : []
      },
      team_score_b: {
        team: resp.team_score_b.team,
        total_goals: resp.team_score_b.score[0].score,
        goals: matchDetail ? matchDetail.team_score_b.goals : []
      },
      clock: resp.clock,
      half_time_score: resp.half_time_score,
      full_time_score: resp.full_time_score,
      extra_time_score: resp.extra_time_score,
      penalty_shootout_score: resp.penalty_shootout_score,
      aggregate_score,
      state: resp.state,
      attendance: resp.attendance,
      referee: resp.referee,
      description: resp.description,
      match_betting_market: resp.match_betting_market,
      venue: resp.venue
    },
    team_statistics_a,
    team_statistics_b
  }
}

function transformTeam(teamPlayers, lineUp, team, formation) {
  return {
    teamName: team.name,
    teamId: team.team_reference.id,
    players: transformPlayers(lineUp, teamPlayers),
    formation
  };
}

function transformPlayers(lineUp, teamPlayers) {
  const players = lineUp.map((player, index) => {
    return {
      ...player,
      id: player.player.player_reference.id,
      name: player.player.display_name,
      shirt_number: player.player.shirt_number,
      starter: player.starter,
      sub: teamPlayers[index] ? teamPlayers[index].sub : {},
      yellowCardTime: teamPlayers[index] ? teamPlayers[index].yellowCardTime : undefined,
      secondYellowCardTime: teamPlayers[index] ? teamPlayers[index].secondYellowCardTime : undefined,
      redCardTime: teamPlayers[index] ? teamPlayers[index].redCardTime : undefined
    };
  });
  return {players};
}

function transformEvent(currentMatch, {match_event: events, last_modified_date}) {
  const transformedEvents = events.map(event => {
    if (event.event.event_type != null) {
      switch (event.event.event_type.event_type) {
        case GOAL:
          goalEvent(currentMatch.match_detail, event, null);
          break;
        case OWNGOAL:
          goalEvent(currentMatch.match_detail, event, 'og');
          break;
        case PENALTY:
          goalEvent(currentMatch.match_detail, event, 'pen');
          break;
        case REDCARD:
          cardEvent(currentMatch, event, REDCARD);
          break;
        case YELLOWCARD:
          cardEvent(currentMatch, event, YELLOWCARD);
          break;
        case SECONDYELLOWCARD:
          cardEvent(currentMatch, event, SECONDYELLOWCARD);
          break;
        case SUBON:
          subEvent(currentMatch, event, SUBON);
          break;
        case SUBOFF:
          subEvent(currentMatch, event, SUBOFF);
          break;
        default:
          break;
      }
    }
    return {
      events: {[event.match_event_reference.id]: event}
    };
  }).reduce((prev, current) => ({
    events: {...prev.events, ...current.events}
  }), {events: {}});
  transformedEvents.last_modified_date = last_modified_date;
  return transformedEvents;
}

export function cardEvent(currentMatch, event, cardColour) {
  const player = teamPlayerEventOccursUpon(currentMatch, event);
  // each player should only ever have at most one of each card (e.g. cannot have 2 red cards)
  switch (cardColour) {
    case YELLOWCARD:
      player.yellowCardTime = event.match_time;
      break;
    case SECONDYELLOWCARD:
      player.secondYellowCardTime = event.match_time;
      break;
    case REDCARD:
      player.redCardTime = event.match_time;
      break;
  }
}

export function subEvent(currentMatch, event, subDirection) {
  const player = teamPlayerEventOccursUpon(currentMatch, event);
  if (!player) {
    return;
  }
  if (subDirection == SUBON) {
    player.sub.subbedOn = true;
    player.sub.onTime = event.match_time;
  } else if (subDirection == SUBOFF) {
    player.sub.subbedOff = true;
    player.sub.offTime = event.match_time;
  }
}

export function teamPlayerEventOccursUpon(currentMatch, event) {
  const teamPlayers = homeOrAwayPlayers(currentMatch, event.event.team.team_reference.id);
  return teamPlayers.players.find(player => {
    return player.id == _.get(event, 'event.player.player_reference.id', "none");
  });
}

function homeOrAwayPlayers(currentMatch, teamReferenceId) {
  if (teamReferenceId == currentMatch.homeTeam.teamId) {
    return currentMatch.homeTeam.players;
  }
  else {
    return currentMatch.awayTeam.players;
  }
}

export function goalEvent(currentMatch, event, goalType) {

  const team = teamEventOccursUpon(currentMatch, event);

  if (team && event && currentMatch) {
    updateTeamGoalScorer(team, event, goalType);
  }
}

function updateTeamGoalScorer(teamScore, goalEvent, goalType) {

  const {
    event: {
      player: {
        player_reference: {
          id: goalScorerId
        } = {},
        display_name: playerDisplayName = ""
      } = {}
    } = {},
    match_event_reference: {
      id: goalEventMatchId
    } = {},
    match_time: goalEventMatchTime
  } = goalEvent || {};

  const {
    goals: teamGoals = []
  } = teamScore || {};

  let goalScorerHasAlreadyScored;

  teamGoals.forEach(goalScorer => {
    if (goalScorer.id == goalScorerId) {
      goalScorerHasAlreadyScored = goalScorer;

      // Check if this is an update for a previous event and remove the old one if so
      let filteredGoals = goalScorer.goal.filter((event) => event.event_id != goalEventMatchId);
      if(filteredGoals.length != goalScorer.goal.length) {
        goalScorer.goal = filteredGoals;
      }

      goalScorer.goal.push({
        type: goalType,
        time: goalEventMatchTime,
        event_id: goalEventMatchId,
        event_time: goalEvent.date
      });
    }
  });

  if (goalScorerHasAlreadyScored == undefined) {
    teamGoals.push({
      team_player: playerDisplayName,
      id: goalScorerId,
      goal: [
        {
          type: goalType,
          time: goalEventMatchTime,
          event_id: goalEventMatchId,
          event_time: goalEvent.date
        }
      ]
    });
  }
}

function teamEventOccursUpon(currentMatch, event) {

  const {
    event: {
      team: {
        team_reference: {
          id: scoringTeamId
        } = {}
      } = {}
    } = {}
  } = event || {};

  const {
    team_score_a: {
      team: {
        team_reference: {
          id: teamAId
        } = {}
      } = {}
    } = {},
    team_score_a: teamScoreA,
    team_score_b: {
      team: {
        team_reference: {
          id: teamBId
        } = {}
      } = {}
    } = {},
    team_score_b: teamScoreB
  } = currentMatch || {};

  if (scoringTeamId) {
    if (scoringTeamId == teamAId) {
      return teamScoreA;
    } else if (scoringTeamId == teamBId) {
      return teamScoreB;
    }
  }
}



// WEBPACK FOOTER //
// ./modules/Football/reducers/match.js